import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import {
  TProductSeriesDetailOverviewSolutionFields,
  TProductSeriesDetailOverviewSolutionProps,
  TProductSolutionCardInnerComponent,
} from '../../@shared/solutions/types/solutions.types';

export class TProductSeriesDetailOverviewSolutionModel {
  private readonly fields?: TProductSeriesDetailOverviewSolutionFields;
  private readonly rendering?: ComponentRendering;

  constructor(props: TProductSeriesDetailOverviewSolutionProps) {
    this.fields = props?.fields || null;
    this.rendering = props?.rendering;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get title(): string {
    return this.fields?.apiData?.title || '';
  }

  get innerComponents(): TProductSolutionCardInnerComponent[] {
    return this.fields?.apiData?.innerComponents || [];
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
